module.exports = __webpack_public_path__ + "static/media/menu-boczne-polityka-prywatnosci_BLUE.7682179c.svg";